import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import {
  TimelineWrapper,
  TimelineItem,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
  TimelineHeader,
  TimelineAction,
  TimelineActor,
  TimelineTimestamp,
  TimelineExpandedContent,
  EmptyState,
  ExpandToggle,
} from './styles'

export const DefaultTimeline = ({ items }) => {
  const { t } = useTranslation('common')
  const [expandedIndex, setExpandedIndex] = useState(null)

  if (!items || items.length === 0) {
    return <EmptyState>{t('common:empty.noTimelineItems')}</EmptyState>
  }

  const handleToggle = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index))
  }

  return (
    <TimelineWrapper>
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        const isExpanded = expandedIndex === index
        return (
          <TimelineItem key={`tl-item-${index}`} $last={isLast}>
            <TimelineDot $color={item.color} />
            {!isLast && <TimelineConnector />}
            <TimelineContent>
              <TimelineHeader>
                {item.icon && <span>{item.icon}</span>}
                <TimelineAction>{item.action}</TimelineAction>
                {item.actor && <TimelineActor>{item.actor}</TimelineActor>}
                {item.timestamp && <TimelineTimestamp>{item.timestamp}</TimelineTimestamp>}
              </TimelineHeader>
              {item.expandedContent && (
                <>
                  <ExpandToggle type="button" onClick={() => handleToggle(index)}>
                    {isExpanded ? t('common:buttons.showLess') : t('common:buttons.showMore')}
                  </ExpandToggle>
                  <TimelineExpandedContent $visible={isExpanded}>
                    {item.expandedContent}
                  </TimelineExpandedContent>
                </>
              )}
            </TimelineContent>
          </TimelineItem>
        )
      })}
    </TimelineWrapper>
  )
}

DefaultTimeline.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      action: PropTypes.string.isRequired,
      actor: PropTypes.string,
      timestamp: PropTypes.string,
      icon: PropTypes.node,
      color: PropTypes.string,
      expandedContent: PropTypes.node,
    })
  ),
}

DefaultTimeline.defaultProps = {
  items: [],
}
